export const APP_VERSION = 'd663cc0'; // to be replaced during build

const hostname = window.location.hostname;
const isProd = window.location.hostname.endsWith('voltasoftware.it');
const isStaging = window.location.hostname.endsWith('volta-software.it');
const protocol = window.location.protocol.replace(':', '');

const findUrl = () => {
  if (['localhost', '127.0.0.1'].includes(hostname)) { // Dev env
    return 'http://localhost:8069';
  }
  if (hostname.endsWith('.local')) { // Local DNS tests
    return (
      protocol + '://' + hostname.replace('-b2b.', '-backend.')
    ) + ':8069';
  }
  return (
    protocol + '://' + hostname.replace('-b2b.', '-backend.')
  );
};

export const BASE_URL = findUrl();

export const environment = {
  production: isProd || isStaging,
  env_name: isProd ? 'PROD' : isStaging ? 'STAGING' : 'DEV',
  BASE_URL_API: BASE_URL + '/v1/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
